module.exports = __webpack_public_path__ + "static/media/photo-4.ca9cbaff.webp";